import * as debounce from 'lodash.debounce'

const debouncedResizeEvent = new Event('debouncedResize')

init()

function init () {
  bindResizeEvents()
}

function bindResizeEvents () {
  window.addEventListener('resize', debounce(handleResize, 100))
}

function handleResize () {
  window.dispatchEvent(debouncedResizeEvent)
}